import { SurveyOutline, SurveySquare } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Survey];

const config: ContentConfigProps = {
  routes: {
    create: routes.SurveyCreator,
    edit: routes.SurveyEditor,
    details: routes.SurveyDetails,
    manageDetails: routes.AdminSurveyDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: SurveyOutline,
    Create: SurveyOutline,
    Icon: SurveySquare,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
